import CometMarquee from 'comet-marquee';
// import 'comet-marquee/dist/comet-marquee.css';

const capabilitiesMarqueeArr = document.querySelectorAll('.capabilities-marquee');
capabilitiesMarqueeArr.forEach((capabilitiesMarqueeEl, i) => {
  const capabilitiesMarquee = new CometMarquee(capabilitiesMarqueeEl, {
    speed: 50,
    pauseOnHover: false,
    initialShift: true,
    pauseOnInvisible: true,
    syncPause: true,
    repeatCount: 3,
    forceAnimation: window.innerWidth >= 1033,
    forceAnimationWidth: window.innerWidth >= 1033 ? 3 : false,
    fullWidth: window.innerWidth >= 1033,
  });
})